module.exports = __webpack_public_path__ + "static/media/loading-ellipsis.4c641f65.svg";